import {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";

import image1 from "../../../../assets/images/Blog58/image1.png";
import image6 from "../../../../assets/images/Blog58/image6.png";
import image16 from "../../../../assets/images/Blog58/image16.png";
import image21 from "../../../../assets/images/Blog58/image21.png";
import image28 from "../../../../assets/images/Blog58/image28.png";
import image33 from "../../../../assets/images/Blog58/image33.png";
import image35 from "../../../../assets/images/Blog58/image35.png";
import image44 from "../../../../assets/images/Blog58/image44.png";
import image49 from "../../../../assets/images/Blog58/image49.png";
import image68 from "../../../../assets/images/Blog58/image68.png";
import image104 from "../../../../assets/images/Blog58/image104.png";
import image107 from "../../../../assets/images/Blog58/image107.png";
import image108 from "../../../../assets/images/Blog58/image108.png";
import image113 from "../../../../assets/images/Blog58/image113.png";
import BlogImagePopper from "./BlogImageLarge";

const Blog58 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – March 2, 2026</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Geopolitical Shock Absorbed, Positioning Stress and Inflation Undercurrents Shape the Tape</p>
        <p>
          Markets move into early March, navigating an environment where geopolitical escalation was anticipated but still capable of unsettling positioning. The response across assets reflects
          adjustment rather than disorder, with flows shifting toward safety before stabilising — highlighting a system that remains liquid even as uncertainty rises.
        </p>
        <p>
          Beneath the surface, participation appears increasingly selective. Bonds briefly reclaimed their haven role, while liquid technology names absorbed selling pressure despite strong
          operational performance. The resulting price action suggests that stress is rotating through positioning rather than undermining the broader structure.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Anticipation Absorbed, Structure Intact</p>

              <p>
                Equity markets continue to absorb geopolitical developments without losing structural footing. Oil and gas markets had already been trending higher ahead of escalation, reinforcing
                that current moves represent amplification of an existing trajectory rather than a new shock.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt="rushed Iranian oil exports signalled attack incoming"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Risk-off behaviour was evident but limited in duration. Digital assets sold off before recovering, and sovereign bonds reasserted their haven role after yields briefly crossed key
                thresholds. This behaviour underscores a market pricing downside, but not expecting prolonged disruption.
              </p>
              <p>
                Equities also reflected positioning dynamics. Despite strong operational performance, highly liquid names such as NVIDIA experienced declines, suggesting that de-risking flows were
                expressed through liquid assets rather than broad selling pressure.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image49}
                    alt="NVDA at key support"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image49)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Forward expectations remain supported by investment and consumption trends, with projections suggesting growth that exceeds consensus assumptions for the year ahead.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image33}
                    alt="GS seeing upside to GDP"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image33)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Inflation Pressure Meets Liquidity Expansion</p>
              <p>Producer price data surprised to the upside, introducing short-term margin pressure and reinforcing sensitivity to cost trends.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image16}
                    alt="PPI rise has limited effect for now"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image16)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                The data were service-heavy and do not yet materially alter inflation trajectories, but they highlight potential pressure on profit margins until clarity emerges regarding whether
                recent strength reflects a temporary print or a sustained shift.
              </p>
              <p>Global money supply continues to reach new highs — a dynamic historically supportive of gold and risk assets alike.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image21}
                    alt="Global ms jump"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image21)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Bond markets reflected ongoing debate between safety demand and inflation persistence. Yields briefly moved through key levels before renewed demand suggested continued appetite for
                sovereign assets.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image35}
                    alt="US10Y challenging breakout setup"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image35)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Energy remains a key variable. Increased freight costs and delivery risks introduce potential volatility even in the absence of structural supply disruption.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Stable Structure, But Increasingly Flow-Driven</p>
              <p>Market structure remains broadly intact, though recent behaviour suggests momentum is being shaped more by positioning than by changes in underlying growth expectations.</p>
              <p>
                The sharp reaction in highly liquid technology names despite strong operational performance highlights the role of risk management flows. The selloff in NVIDIA following strong results
                suggests that liquid names are being used as vehicles for de-risking rather than reflecting fundamental reassessment.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image49}
                    alt="NVDA at key support"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image49)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                This weakness occurred even as broader indices held relatively stable, indicating that risk-off expression has been concentrated in the most tradable exposures rather than across the
                market.
              </p>
              <div className="relatedImg">
                <img
                  src={image44}
                  alt="what now for SPX500"
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image44)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>Sideways movement across indices appears to reflect both geopolitical anticipation and rotation toward defensive positioning rather than a collapse in conviction.</p>
              <p>Sentiment indicators have now crossed into bearish territory.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image68}
                    alt="bears over bulls at AAII pivot soon"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image68)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>At the same time, positioning skew shows an increased focus on downside protection, with put demand elevated relative to calls.</p>
              <p>
                This shift toward defensive positioning reflects a market more concerned with downside outcomes than upside opportunity, increasing the likelihood that short-term volatility may be
                driven by positioning dynamics rather than macro deterioration.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Inflation Signals and Labour Dynamics</p>
              <p>
                Recent developments reflected the coexistence of rising cost pressures and continued labour resilience, reinforcing a backdrop where growth remains intact even as profitability
                dynamics face short-term pressure.
              </p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span>
                    <br></br> Producer prices exceeded expectations, creating short-term margin pressure while leaving broader inflation expectations largely intact. The strength was driven primarily
                    by services, suggesting a temporary squeeze on profitability rather than a shift in long-term pricing trends.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image16}
                        alt="PPI rise has limited effect for now"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image16)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image28}
                        alt="clear downward trend in jobless claims"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image28)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span>
                    <br></br>Strong performance from major technology firms was met with hesitation in price action, reflecting positioning adjustments rather than earnings-driven reassessment.
                    Selling in liquid names appeared to reflect risk management flows rather than a reassessment of long-term growth narratives.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image49}
                        alt="NVDA at key suppor"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image49)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities:</span>
                    <br></br> Global liquidity expansion continued to support real assets, with money supply reaching new highs and reinforcing a constructive backdrop. Geopolitical developments
                    contributed to increased sensitivity across resource markets.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image21}
                        alt=" global ms jump"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image21)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image6}
                        alt="Rushed Iranian oil exports signalled attack incoming"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image6)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span>
                    <br></br> Digital assets behaved in line with broader risk sentiment rather than acting as defensive instruments, highlighting their continued linkage to liquidity conditions.
                    Positioning remained influenced by technology sector flows and broader software risk sentiment.
                  </p>
                </li>
                <div
                  className="imageWrapperCont"
                  style={{marginTop: "22px"}}
                >
                  <div className="relatedImg">
                    <img
                      src={image107}
                      alt="bitcoin not a liquidity hedge at the moment"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image107)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image108}
                      alt="bitcoin tracking software risk off"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image108)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil:</span>
                    <br></br> Energy markets responded to developments that had been partially anticipated, with price dynamics reflecting both supply expectations and transport-related risk. Freight
                    risk and delivery premiums added another layer of sensitivity to pricing behaviour.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image104}
                      alt="crude back in crucial ranges"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image104)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Key Data and Market-Moving Signals</p>
              <p>
                The week is centred on labour market strength and activity data, with ISM releases and Non-Farm Payrolls acting as the primary macro signals. At the same time, markets will continue to
                assess the duration of the ongoing conflict, given its influence on oil sensitivity and broader risk positioning.
              </p>
              <p className="highlightedText">Monday, March 2</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText"> Australia: </span> MI Inflation Gauge, Company Profits, Business Inventories
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText"> Japan:</span> Manufacturing PMI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText"> India:</span> Manufacturing PMI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Germany:</span> Retail Sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> Manufacturing PMI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> Manufacturing PMI, Mortgage Lending and Credit Data
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> ISM Manufacturing PMI and Employment Components
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Atlanta Fed GDPNow Update
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> Unemployment Rate and Capital Spending
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, March 3</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> BRC Shop Price Index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Australia:</span> Current Account and Building Approvals
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">Eurozone:</span> : CPI and Core CPI
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Economic Optimism Index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> API Weekly Crude Oil Stocks
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, March 4</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">Australia: </span> GDP
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> Manufacturing and Services PMI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText"> India:</span> Services PMI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> : Services PMI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">US: </span> ADP Nonfarm Employment
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">US: </span> ISM Non-Manufacturing PMI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span>Crude Oil Inventories
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span>Beige Book
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, March 5</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Australia:</span> Trade Balance
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">Eurozone: </span>Construction PMI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span>Jobless Claims
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> Trade Balance
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> Unit Labour Costs
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> Factory Orders
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Friday, March 6</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">Eurozone: </span> GDP
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> Retail Sales
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> Non-Farm Payrolls
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> Unemployment Rate
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> Average Hourly Earnings
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image113}
                    alt="EW 020326"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image113)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Adjustment Within an Intact Framework</p>
              <p>Markets continue to navigate evolving pressures without abandoning the broader growth narrative, with positioning shifts shaping near-term behaviour more than structural change.</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br></br> Rotation remains active, with liquid technology names absorbing positioning adjustments even as underlying performance remains strong. Recent selling appears linked to
                    de-risking flows rather than a reassessment of long-term growth drivers.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span> <br></br> Liquidity expansion continues to provide structural support amid uncertainty, reinforcing their role as
                    beneficiaries of global money supply trends.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span> <br></br>Behaviour remains aligned with broader risk sentiment rather than functioning as a defensive asset, with price action
                    continuing to track shifts in technology sector sentiment.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span> <br></br> Cost pressures and labour resilience are shaping expectations, reinforcing the importance of monitoring inflation trends
                    and employment signals as growth remains broadly supported.
                  </p>
                </li>
              </ul>

              <p className="highlightedText">
                Markets appear to be transitioning from complacency toward caution rather than toward contraction. Liquidity remains a stabilising force, even as positioning dynamics introduce
                episodic volatility.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image68}
                    alt="Bears over bulls at AAII pivot soon"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image68)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image35}
                    alt="US10Y challenging breakout setup"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image35)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image21}
                    alt="global ms jump"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image21)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/19vxXQWfO3QM3db7XFZuqieC7a1A_kWgRHbOsS0Biwqc/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog58;
